import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
export function FinalCTA() {
  return <section className="py-24 md:py-32 px-6 bg-primary text-white text-center relative overflow-hidden" data-id="element-35">
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/food.png')] opacity-10 mix-blend-overlay" data-id="element-36"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-37">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-38">
          <h2 className="text-4xl md:text-6xl font-serif font-bold mb-6 leading-tight" data-id="element-39">
            Volvé a disfrutar las comidas que te gustan
          </h2>
          <p className="text-xl md:text-2xl text-green-100 mb-12 max-w-2xl mx-auto" data-id="element-40">
            Más de 100 recetas para personas con diabetes, prediabetes o
            resistencia a la insulina.
          </p>

          <Button className="bg-white text-primary hover:bg-gray-100 text-xl px-12 py-6 shadow-2xl" data-id="element-41">
            QUIERO ACCEDER AHORA
          </Button>
        </motion.div>
      </div>
    </section>;
}